var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReceiptCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.2353 10.141L11.1669 12.0727L15.5131 7.72651M19.8592 20.282V7.53335C19.8592 5.91064 19.8592 5.09928 19.5434 4.47949C19.2656 3.9343 18.8224 3.49105 18.2772 3.21326C17.6574 2.89746 16.846 2.89746 15.2233 2.89746H9.04214C7.41943 2.89746 6.60807 2.89746 5.98827 3.21326C5.44309 3.49105 4.99984 3.9343 4.72205 4.47949C4.40625 5.09928 4.40625 5.91064 4.40625 7.53335V20.282L7.06223 18.3504L9.47675 20.282L12.1327 18.3504L14.7887 20.282L17.2032 18.3504L19.8592 20.282Z",
    stroke: "#344054",
    strokeWidth: 1.93162,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceiptCheck);
export default __webpack_public_path__ + "static/media/receipt-check.247ad987e4e93999397152e704e64eb6.svg";
export { ForwardRef as ReactComponent };